/**
 * LuxPill — small uppercase eyebrow / urgency badge.
 * Variants:
 *   "default" — gold, hairline-bordered (used for section labels)
 *   "urgent"  — red/orange gradient (used for "25% OFF" markers)
 */
const LuxPill = ({ variant = "default", className = "", children, ...rest }) => {
  const cls = variant === "urgent" ? "lux-pill lux-pill-urgent" : "lux-pill";
  return (
    <span className={`${cls} ${className}`.trim()} {...rest}>
      {children}
    </span>
  );
};

export default LuxPill;
